<div class="tp">
  <header class="tp__hero">
    <div class="tp__eyebrow">
      <span class="tp__eyebrow-rule" aria-hidden="true"></span>
      Geführte Anfrage
    </div>
    <h1 class="tp__title cr-display">Was brauchst du?</h1>
    <p class="tp__lead">Wähle dein Gewerk — ab da führen wir dich in 3 – 5 Klicks durch die Anfrage.</p>
  </header>

  <div class="tp__grid">
    @for (t of trades; track t.id) {
      <button type="button" class="tp__tile" (click)="picked.emit(t)">
        <span class="tp__glyph cr-mono">{{ glyphFor(t.name) }}</span>
        <span class="tp__tile-name">{{ t.name }}</span>
        <svg class="tp__tile-arrow" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M5 12h14M13 5l7 7-7 7"/>
        </svg>
      </button>
    }
  </div>
</div>
